import React, { useEffect } from "react";
import {useSelector , useDispatch} from "react-redux";
import { eventmessageDeleteAction } from "../redux/slices/eventSlices";
import { usermessageDeleteAction } from "../redux/slices/userSlices";
import { teammessageDeleteAction } from "../redux/slices/teamSlices";
import { quizmessageDeleteAction } from "../redux/slices/quizSlices";
import '../styles/message.css';


export default function Message(){
    const userStoreData  = useSelector(store => store.users);
    const eventStoreData  = useSelector(store => store.event);
    const quizStoreData  = useSelector(store => store.quiz);
    const teamStoreData  = useSelector(store => store.team);

    const dispatch = useDispatch();

    const {message : userMessage , appError : userError} = userStoreData;
    const {message : eventMessage , appError : eventError} = eventStoreData;
    const {message : teamMessage , appError : teamError} = teamStoreData;
    const {message : quizMessage , appError : quizError} = quizStoreData;


    useEffect(()=>{
        if(userMessage || userError){
            setTimeout(()=>{
                dispatch(usermessageDeleteAction());
            },3000);
        }

        if(eventMessage || eventError){
            setTimeout(()=>{
                dispatch(eventmessageDeleteAction());
            },3000);
        }

        if(teamMessage || teamError){
            setTimeout(()=>{
                dispatch(teammessageDeleteAction());
            },3000);
        }

        if(quizMessage || quizError){
            setTimeout(()=>{
                dispatch(quizmessageDeleteAction());
            },3000);
        }

        
    },[userMessage , userError , eventMessage , eventError , teamMessage , teamError , quizError , quizMessage , dispatch]);    

    return (
        
        // <div className="message">
        // <div style={{backgroundColor : "green"}}>
        //    {userMessage ? <div style={{color : "white" , fontWeight : "bold"}}>{userMessage}</div>: null}
        //    {eventMessage ? <div style={{color : "white" , fontWeight : "bold"}}>{eventMessage}</div>: null}
        //    {teamMessage ? <div style={{color : "white" , fontWeight : "bold"}}>{teamMessage}</div>: null}
        //    {quizMessage ? <div style={{color : "white" , fontWeight : "bold"}}>{quizMessage}</div>: null}
        // </div>
        // <div style={{backgroundColor : "red"}}>
        //    {quizError ? <div style={{color : "white" , fontWeight : "bold"}}>{quizError}</div>: null}
        //    {eventError ? <div style={{color : "white" , fontWeight : "bold"}}>{eventError}</div>: null}
        //    {teamError ? <div style={{color : "white" , fontWeight : "bold"}}>{teamError}</div>: null}
        //    {userError ? <div style={{color : "white" , fontWeight : "bold"}}>{userError}</div>: null}
        // </div>
        // </div>

        <div className="message1">
       
           {userMessage ? <div  >{<div className="msg1">
            <img alt="message"  src="https://img.icons8.com/?size=100&id=88562&format=png&color=000000" />
            {userMessage}</div>} </div>: null}

           {eventMessage ? <div  >{<div className="msg1">
            <img alt="message"  src="https://img.icons8.com/?size=100&id=88562&format=png&color=000000" />
            {eventMessage}</div>} </div>: null}

           {teamMessage ? <div  >{<div className="msg1">
            <img alt="message"  src="https://img.icons8.com/?size=100&id=88562&format=png&color=000000" />
            {teamMessage}</div>} </div>: null}

           {quizMessage ? <div  >{<div className="msg1">
            <img alt="message"  src="https://img.icons8.com/?size=100&id=88562&format=png&color=000000" />
            {quizMessage}</div>} </div>: null}
        
        
           {quizError ? <div>{<div className="error">
            <img alt="message"  src="https://img.icons8.com/?size=100&id=59754&format=png&color=000000" />
            {quizError}</div>} </div>: null}

           {eventError ? <div  >{<div className="error">
            <img alt="message"  src="https://img.icons8.com/?size=100&id=59754&format=png&color=000000" />
            {eventError}</div>} </div>: null}

           {teamError ? <div  >{<div className="error">
            <img alt="message"  src="https://img.icons8.com/?size=100&id=59754&format=png&color=000000" />
            {teamError}</div>} </div>: null}

           {userError ? <div  >{<div className="error">
            <img alt="message"  src="https://img.icons8.com/?size=100&id=59754&format=png&color=000000" />
            {userError}</div>} </div>: null}

        
        </div>
        
    )
}